import { Button, Dialog, Heading, IconClose, Text } from "@idg-web-platform/pulse";
import { useEffect, useRef } from "preact/hooks";
import css from "./accountDeletionDialog.module.css";
import margins from "@idg-web-platform/pulse/cssModules/margins.module.css";

export function AccountDeletionDialog({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.showModal?.();
    } else {
      dialogRef.current?.close?.();
    }
  }, [isOpen]);

  useEffect(() => {
    dialogRef.current?.addEventListener("close", handleClose);
    return () => {
      dialogRef.current?.removeEventListener("close", handleClose);
    };
  }, []);

  const handleClose = () => {
    onClose();
  };

  const handleDeleteAccount = async () => {
    await fetch("/api/c/account/", {
      method: "DELETE",
      redirect: "follow",
    })
      .then((response) => {
        if (response.redirected) {
          window.location.href = response.url;
        }
      })
      .catch((error) => {
        console.error("Error during fetch:", error);
      });
  };

  return (
    <>
      <Dialog ref={dialogRef} role="dialog">
        <div>
          <Heading text={"Meine Club-mitgliedschaft kündigen"} sizeStep={0} />
        </div>

        <Text sizeStep={0} class={margins.pulseMarginBottom2xl}>
          Schade, dass du dein Kundenkonto löschen möchtest.
        </Text>

        <div>
          <Text fontStyle="bold" sizeStep={0} removeMargin={true}>
            Deine Nachteile durch die Löschung:
          </Text>
          <div>
            <ul class={css.listContainer}>
              <div>
                <IconClose />
                <li>
                  Deine CLUB-Mitgliedschaft wird gelöscht und deine CLUB-Punkte gehen verloren.
                </li>
              </div>
              <div>
                <IconClose />
                <li>Du kannst keine CLUB-Punkte mehr sammeln oder einlösen.</li>
              </div>
              <div>
                <IconClose />
                <li>Du kannst nicht mehr versandkostenfrei bestellen.</li>
              </div>
              <div>
                <IconClose />
                <li>Dein Rückgabezeitraum ändert sich von 100 auf 14 Tage.</li>
              </div>
              <div>
                <IconClose />
                <li>
                  Du kannst dich erst nach 30 Tagen erneut mit deiner E-Mail Adresse anmelden.
                </li>
              </div>
            </ul>
          </div>
        </div>

        <div class={css.buttonContainer}>
          <Button
            // class={css.button}
            onClick={handleClose}
            level="secondary"
            text="Abbrechen"
            // isLoading={state.isSigningIn}
          />
          <Button
            // class={css.button}
            onClick={handleDeleteAccount}
            level="primary"
            text="wirklich löschen"
            // isLoading={state.isSigningIn}
          />
        </div>
      </Dialog>
    </>
  );
}
